import React from "react";
import cn from "../../lib/classnames";
import stars from "../../images/5-stars.svg";
import styles from "./ReviewDisplay.module.css";

type Props = {
    description: string;
    dateOfReview: string;
};

export default function ReviewDisplay(props: Props) {
    return (
        <div className={styles.container}>
            <img className={styles.image} src={stars} alt="5 stars" />
            <div className={cn(styles.description, styles.descriptionMarginTop)}>
                {props.description}
            </div>
            <div
                className={cn(styles.description, styles.dateOfReview)}
            >{`- ${props.dateOfReview}`}</div>
        </div>
    );
}
